import { IResponse } from './base';

export enum EStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}
interface IMerchant {
  merchantName: string;
  merchantId: string;
  merchantProfileUrl: string | null;
  status: EStatus;
}

interface IProfile {
  // Current merchantId, it could be company id or merchant id
  merchantId: string;
  companyName: string;
  merchantName: string;
  address: string;
  phoneAreaCode: string;
  phoneNumber: string;
  email: string;
  username: string;
  createTime: number;
  profilePhotoUrl: string;
  isFirstLogin: boolean;
  type: 'MERCHANT' | 'COMPANY';
  merchantList: IMerchant[];
  showUserInfoFlag: boolean;
  contract?: string;
  isOnline: boolean;
}

interface IConfirmContract {
  email?: string;
  newPassword?: string;
}

type IProfileResponse = IResponse<IProfile>;

export { IProfileResponse, IProfile, IMerchant, IConfirmContract };
